// extracted by mini-css-extract-plugin
module.exports = {"letterSlot":"SpellingConnectables_letterSlot__3TkFq"};